import { render, staticRenderFns } from "./CheckboxMarked.vue?vue&type=template&id=1b5fac35&functional=true&"
import script from "./CheckboxMarked.vue?vue&type=script&lang=js&"
export * from "./CheckboxMarked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports